module.exports = __webpack_public_path__ + "img/icon_pjyl.0737be5f.png";